
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Lock } from 'lucide-react';
import { Card } from '../../ui/Card';

export const ZKRelayNode: React.FC = () => {
    return (
        <Card className="p-8 border-stone-200 dark:border-white/5 flex flex-col justify-center h-44 group transition-all duration-300 rounded-sm bg-white dark:bg-[#15171C] shadow-sm">
            <div className="flex items-center gap-4 mb-4">
                <div className="p-2.5 bg-stone-50 dark:bg-white/5 rounded-sm text-[#0A0B0F] dark:text-nobel-gold group-hover:bg-nobel-gold group-hover:text-black transition-colors duration-500">
                    <Lock size={20} />
                </div>
                <span className="text-[10px] font-black uppercase tracking-[0.25em] text-stone-700 dark:text-stone-400">Privacy Protection</span>
            </div>
            <p className="text-[13px] text-stone-500 dark:text-stone-400 leading-relaxed font-medium">Your activity is masked from public tracking to ensure security.</p>
        </Card>
    );
};
